import React, { lazy, Suspense } from "react";
import rg4js from 'raygun4js';
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Protected from "./Protected";
import * as Raygun from 'raygun4js';
import { lazyWithRetry } from "./Utils/lazyWithRetry";
import ChunkErrorBoundary from "./ChunkErrorBoundary";
// Lazy Components


const TokenActivation = lazyWithRetry(() => import('../PagesV2/authentication/TokenActivation'));

const LoginOptions = lazyWithRetry(() => import('../PagesV2/authentication/LoginOptions'));

const PhoneVerification = lazyWithRetry(() => import('../PagesV2/authentication/PhoneVerification'));
const OtpVerify = lazyWithRetry(() => import('../PagesV2/authentication/OtpVerify'));
const NoAccess = lazyWithRetry(() => import('../PagesV2/no-access/NoAccess'));
const TokenExpired = lazyWithRetry(() => import('../PagesV2/no-access/TokenExpired'));
const ChooseUser = lazyWithRetry(() => import("../PagesV2/authentication/ChooseUser"));


const PageLoader = lazy(() => import('../Components/Loaders/PageLoader'));
const NotFound = lazyWithRetry(() => import('../PagesV2/authentication/NotFound'));
// v2
const QuickSetup = lazyWithRetry(() => import("../PagesV2/onboarding/QuickSetup"));
const People = lazyWithRetry(() => import("../PagesV2/people/People"));
const ChatScreen = lazyWithRetry(() => import("../PagesV2/chat/ChatScreen"));
const Tasks = lazyWithRetry(() => import("../PagesV2/tasks/Tasks"));
const AcceptTask = lazyWithRetry(() => import("../PagesV2/tasks/section/AcceptTask"));
const RideDetails = lazyWithRetry(() => import("../PagesV2/rides/RideDetails"));
const VoluntterOppurtunity = lazyWithRetry(() => import("../PagesV2/tasks/section/Opportunity"));

const Meals = lazyWithRetry(() => import("../PagesV2/meals/Meals"));
const MealsDetails = lazyWithRetry(() => import("../PagesV2/meals/details/MealsDetails"));
const AllMealsRoutes = lazyWithRetry(() => import("../PagesV2/meals/AllMealsRoutes"));

const Scanner = lazyWithRetry(() => import("../PagesV2/kitchen/Scanner"));
const KitchenMealsList = lazyWithRetry(() => import("../PagesV2/kitchen/list/KitchenMealsList"));
const KitchenMealsDetails = lazyWithRetry(() => import("../PagesV2/kitchen/details/KitchenMealsDetails"));
const KitchenReport = lazyWithRetry(() => import("../PagesV2/kitchen/report/KitchenReport"));
const KitchenDashboard = lazyWithRetry(() => import("../PagesV2/kitchen/dashboard/KitchenDashboard"));

const MealsOrdering = lazyWithRetry(() => import("../PagesV2/mealsOrdering/MealsOrdering"));
const CreateOrder = lazyWithRetry(() => import("../PagesV2/mealsOrdering/CreateOrder"));

const ToastTestPage = lazyWithRetry(() => import('../PagesV2/dev/ToastTestPage'));
import Access from "../PagesV2/authentication/Access";
import constant from "./Constant";
const PermissionGate = lazyWithRetry(() => import("../ComponentsV2/common/PermissionGate"));
import { settingsStorage } from "../Services/Storage/StorageSections/settings.storage";

export default function RoutesDefinition(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const hostName = window.location.hostname;
    // // Ragyun
    // const errorPayload = {
    //     type: 'manual',
    //     customData: {
    //         message: 'Pwa',
    //     },
    // };
    // rg4js('apiKey', '6E4UtRiVzMNMEQykopPWg');
    // rg4js('enableCrashReporting', true);
    // rg4js('enablePulse', true);
    // rg4js('send', errorPayload);
    // rg4js('saveIfOffline', true);
    // React.useEffect(function () {
    //     rg4js('trackEvent', { type: 'pageView', path: location.pathname });

    // }, [location]);

    // ----------------------
    // React.useEffect(() => {
    //     // Reload on Navigiator
    //     let el = document.querySelector(".connectivity > p > a");
    //     el.addEventListener("click", () => navigate("/ride"))
    // }, [navigate]);


    const Routesitems = [
        "setup",
        "people",
        "meals",
        "meals-details",
        "choose-user",
        "chat",
        "meals-routes",
        "accept-task",
        "kitchen-scanner",
        "kitchen-meals-list",
        "kitchen-meals-details",
        "kitchen-report",
        "kitchen-dashboard",
        "meals-ordering",
        "ride-details",
        "tasks",
        "volunteering-opportunities",
    ];


    React.useEffect(() => {
        const routeCurrent = window.location.href;
        const currentPath = routeCurrent.split('/').pop();
        const hostName = window.location.hostname;

        if (Routesitems.includes(currentPath)) {
            localStorage.setItem("lastVisitedPage", routeCurrent);
        } else {
            let fallbackPath = "/meals"; // default

            if (hostName === constant.mealsDomain) {
                // Land on the section the user can actually access.
                if (settingsStorage.hasPermission("MealsDriver")) {
                    fallbackPath = "/meals";
                } else if (settingsStorage.hasPermission("MobileCreateMealOrders")) {
                    fallbackPath = "/meals-ordering";
                } else {
                    fallbackPath = "/meals";
                }
            } else if (constant.kitchenProtectedDomains.includes(hostName)) {
                fallbackPath = "/kitchen-meals-list";
            } else if (hostName === constant?.driversDomain) {
                fallbackPath = "/ride";
            }

            localStorage.setItem("lastVisitedPage", `${window.location.origin}${fallbackPath}`);
        }
    }, [location]);



    return (
        <>
            <ChunkErrorBoundary key={location.key}>
                <Suspense fallback={<PageLoader allowloader />}>
                    <Routes>
                        <Route exact path="/" element={<Access />} />
                        <Route exact path="/login-options" element={<LoginOptions />} />
                        <Route index path="/verifyByToken" element={<TokenActivation />} />
                        <Route index path="/phone-verification" element={<PhoneVerification />} />
                        <Route exact path="/otpverify" element={<OtpVerify />} />


                        {/* v2 */}
                        <Route exact path="/setup" element={<QuickSetup />} />
                        <Route exact path="/people" element={<People />} />
                        <Route exact path="/meals" element={<PermissionGate permission="MealsDriver" name="Meals"><Meals /></PermissionGate>} />
                        <Route exact path="/meals-details" element={<PermissionGate permission="MealsDriver" name="Meals"><MealsDetails /></PermissionGate>} />
                        <Route exact path="/choose-user" element={<ChooseUser />} />
                        <Route exact path="/chat" element={<ChatScreen />} />
                        <Route exact path="/meals-routes" element={<PermissionGate permission="MealsDriver" name="Meals"><AllMealsRoutes /></PermissionGate>} />
                        <Route exact path="/accept-task" element={<AcceptTask />} />

                        <Route exact path="/kitchen-scanner" element={<Protected mode="kitchen" name="Kitchen Scanner"><Scanner /></Protected>} />
                        <Route exact path="/kitchen-meals-list" element={<Protected mode="kitchen" name="Kitchen Meals List"><KitchenMealsList /></Protected>} />
                        <Route exact path="/kitchen-meals-details" element={<Protected mode="kitchen" name="Kitchen Meals Details"><KitchenMealsDetails /></Protected>} />
                        <Route exact path="/kitchen-report" element={<Protected mode="kitchen" name="Kitchen Report"><KitchenReport /></Protected>} />
                        <Route exact path="/kitchen-dashboard" element={<Protected mode="kitchen" name="Kitchen Dashboard"><KitchenDashboard /></Protected>} />

                        <Route exact path="/meals-ordering" element={<Protected mode="meals" name="Meals Ordering"><PermissionGate permission="MobileCreateMealOrders" name="Meals Ordering"><MealsOrdering /></PermissionGate></Protected>} />

                        <Route exact path="/meals-ordering/create" element={<Protected mode="meals" name="Create Order"><PermissionGate permission="MobileCreateMealOrders" name="Meals Ordering"><CreateOrder /></PermissionGate></Protected>} />

                        <Route exact path="/ride-details" element={<RideDetails />} />

                        <Route exact path="/tasks" element={<Tasks />} />
                        <Route exact path="/volunteering-opportunities" element={<VoluntterOppurtunity />} />



                        <Route exact path="/noaccess" element={<NoAccess />} />
                        <Route exact path="/token-expired" element={<TokenExpired />} />


                        <Route exact path="/dev/test/toast" element={<ToastTestPage />} />
                        {/* <Route exact path="/check" element={<CheckPWA />} /> */}
                        <Route path='*' element={<NotFound />}></Route>
                    </Routes>
                </Suspense>
            </ChunkErrorBoundary>
        </>
    );
}
